import { Component, Input, OnInit, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

export const WIDGET_DROPDOWN_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => V4DropdownComponent),
  multi: true,
};

@Component({
  selector: "v4-widget-dropdown",
  templateUrl: "./dropdown.component.html",
  styleUrls: ["./dropdown.component.scss"],
  providers: [WIDGET_DROPDOWN_VALUE_ACCESSOR],
})
export class V4DropdownComponent implements OnInit, ControlValueAccessor {
  @Input() options: Option[] = [];

  checkedValues: Set<any> = new Set();

  _registerOnChange: (value: any) => void = (_: any) => {};
  constructor() {}

  ngOnInit() {}

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: any[] | null): void {
    this.checkedValues = new Set(value ? value : []);
  }

  onCheck(option: Option) {
    if (this.checkedValues.has(option.value)) {
      this.checkedValues.delete(option.value);
    } else {
      this.checkedValues.add(option.value);
    }

    this._registerOnChange(Array.from(this.checkedValues));
  }
}
